import {Button, Layout, Spacer, Text} from '@di-nxt/components';
import {Screen} from '../../components';
import React, {useCallback} from 'react';
import {useLogout} from '../../services';
import {t} from '../../localization';
export const NoTeamScene: React.FC = () => {
  const logout = useLogout();
  const handleLogout = useCallback(() => {
    logout();
  }, [logout]);
  return (
    <Screen>
      <Layout centered flex>
        <Layout vertical width={360}>
          <Text variant={'inline_24_emphasis'}>
            {t('screens.noteam.title')}
          </Text>
          <Spacer height={'20'} />
          <Text variant="paragraph_16_default">{t('screens.noteam.body')}</Text>
          <Spacer height="40" />
          <Button
            size="Large"
            title={t('screens.noteam.button')}
            onPress={handleLogout}
            inline
          />
        </Layout>
      </Layout>
    </Screen>
  );
};
